module.exports = __webpack_public_path__ + "static/media/guest.1652718a.svg";